var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "Editor-task" } }, [
    _c("div", { staticClass: "editor-task" }, [
      _c(
        "div",
        { staticClass: "editor-task-header" },
        [
          _c(
            "a-select",
            {
              staticClass: "editor-task-todo-select",
              attrs: { placeholder: "ToDo" },
            },
            [
              _c("a-select-option", { attrs: { value: "ToDo" } }, [
                _vm._v("To Do"),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "Compledet" } }, [
                _vm._v("Compledet"),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "In" } }, [_vm._v("In")]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "Done" } }, [
                _vm._v("Done"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-button",
            { staticClass: "editor-re-open-btn", attrs: { block: "" } },
            [
              _c(
                "span",
                {
                  staticClass: "md-icon",
                  staticStyle: { "margin-right": "3px" },
                },
                [_vm._v("restart_alt")]
              ),
              _vm._v("\n                Re-Open\n            "),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "editor-task-content" }, [
        _c(
          "div",
          { staticClass: "editor-task-quill-editor" },
          [
            _c("quill-editor", {
              staticClass: "quill-editor",
              staticStyle: { "max-height": "20%", width: "100%" },
              attrs: {
                options: _vm.editorOption,
                placeholder: "Task Description",
              },
              model: {
                value: _vm.form.description,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "description", $$v)
                },
                expression: "form.description",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "editor-task-new-checklist" }, [
          _c("div", { staticClass: "checklist-data" }, [
            _vm.form.checklist.length > 0
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "20px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "16px",
                          "margin-right": "20px",
                        },
                      },
                      [_vm._v("Checklist")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { width: "200px" } },
                      [
                        _c("a-progress", {
                          attrs: {
                            "stroke-color": {
                              "0%": "ec4b1d",
                              "100%": "ec4b1d",
                            },
                            percent:
                              (100 / _vm.form.checklist.length) *
                              _vm.form.checklist.filter(function (c) {
                                return c.isCompleted
                              }).length,
                            "show-info": false,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { width: "200px" } }, [
                      _vm._v(
                        "\n                            Completed: " +
                          _vm._s(
                            _vm.form.checklist.filter(function (c) {
                              return c.isCompleted
                            }).length
                          ) +
                          " out of\n                            " +
                          _vm._s(_vm.form.checklist.length) +
                          "\n                        "
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "10px",
                  display: "flex",
                  gap: "10px",
                  "flex-direction": "column",
                },
              },
              _vm._l(_vm.form.checklist, function (checkbox, index) {
                return _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "flex-start",
                      "user-select": "none",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          gap: "10px",
                        },
                      },
                      [
                        _c("a-checkbox", {
                          staticClass: "kanban-checkbox large",
                          model: {
                            value: checkbox.isCompleted,
                            callback: function ($$v) {
                              _vm.$set(checkbox, "isCompleted", $$v)
                            },
                            expression: "checkbox.isCompleted",
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: checkbox.title,
                              expression: "checkbox.title",
                            },
                          ],
                          staticStyle: {
                            width: "300px",
                            border: "none",
                            outline: "none",
                            background: "#f1f1f1",
                            "border-radius": "4px",
                            padding: "3px 10px",
                          },
                          domProps: { value: checkbox.title },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(checkbox, "title", $event.target.value)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "material-icons",
                        on: {
                          click: function ($event) {
                            return _vm.deleteCheckbox(index)
                          },
                        },
                      },
                      [_vm._v("close")]
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "10px",
                  color: "#ec4b1d",
                  "font-weight": "bold",
                  cursor: "pointer",
                },
                on: { click: _vm.addNewCheckBox },
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      !_vm.form.checklist.length ? "New Checklist" : "Add"
                    ) +
                    "\n                    "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "editor-task-attach-files" }, [
          _c("div", { staticClass: "attach-files" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "logo" }, [_c("s3Logo")], 1),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "editor-task-new-subtask" }, [
          _vm.form.subTasks.length > 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "10px",
                    display: "flex",
                    gap: "10px",
                    "flex-direction": "column",
                  },
                },
                _vm._l(_vm.form.subTasks, function (subtask, index) {
                  return _c("div", [
                    !subtask.isExits
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "space-between",
                              "user-select": "none",
                              gap: "20px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  gap: "10px",
                                  width: "100%",
                                },
                              },
                              [
                                _c("a-checkbox", {
                                  staticClass: "kanban-checkbox large",
                                  model: {
                                    value: subtask.completed,
                                    callback: function ($$v) {
                                      _vm.$set(subtask, "completed", $$v)
                                    },
                                    expression: "subtask.completed",
                                  },
                                }),
                                _vm._v(" "),
                                _c("a-input", {
                                  staticClass: "classic-new-input",
                                  attrs: { placeholder: "SubTask Title" },
                                  model: {
                                    value: subtask.title,
                                    callback: function ($$v) {
                                      _vm.$set(subtask, "title", $$v)
                                    },
                                    expression: "subtask.title",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { width: "100%" } },
                              [
                                _c("a-select", {
                                  staticClass: "select-multiple",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    options: _vm.users,
                                    placeholder: "Assignee",
                                  },
                                  model: {
                                    value: subtask.assignees,
                                    callback: function ($$v) {
                                      _vm.$set(subtask, "assignees", $$v)
                                    },
                                    expression: "subtask.assignees",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "material-icons",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteSubtask(index)
                                  },
                                },
                              },
                              [_vm._v("close")]
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "space-between",
                              "user-select": "none",
                              gap: "20px",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { width: "100%" } },
                              [
                                _c("a-select", {
                                  staticClass: "select-multiple",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    options: _vm.users,
                                    placeholder: "Assignee",
                                  },
                                  model: {
                                    value: subtask.taskId,
                                    callback: function ($$v) {
                                      _vm.$set(subtask, "taskId", $$v)
                                    },
                                    expression: "subtask.taskId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "material-icons",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteSubtask(index)
                                  },
                                },
                              },
                              [_vm._v("close")]
                            ),
                          ]
                        ),
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row gap-10" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "10px",
                  color: "#ec4b1d",
                  "font-weight": "bold",
                  cursor: "pointer",
                },
                on: {
                  click: function ($event) {
                    return _vm.addNewSubtask(false)
                  },
                },
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s("Add Subtasks") +
                    "\n                    "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "10px",
                  color: "#ec4b1d",
                  "font-weight": "bold",
                  cursor: "pointer",
                },
                on: {
                  click: function ($event) {
                    return _vm.addNewSubtask(true)
                  },
                },
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s("Add Exits Subtasks") +
                    "\n                    "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "editor-info" }, [
      _c("div", { staticClass: "info-task-list" }, [
        _c("div", { staticClass: "info-task-item" }, [
          _c("label", [_vm._v("Start Date")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "info-task-item-value" },
            [
              _c("a-date-picker", {
                model: {
                  value: _vm.form.startDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "startDate", $$v)
                  },
                  expression: "form.startDate",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-task-item" }, [
          _c("label", [_vm._v("End Date")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "info-task-item-value" },
            [
              _c("a-date-picker", {
                model: {
                  value: _vm.form.endDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "endDate", $$v)
                  },
                  expression: "form.endDate",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-task-item" }, [
          _c("label", [_vm._v("Priority")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "info-task-item-value" },
            [
              _c(
                "a-select",
                {
                  staticStyle: { width: "167px" },
                  model: {
                    value: _vm.form.priority,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "priority", $$v)
                    },
                    expression: "form.priority",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "low" } }, [
                    _vm._v("Low"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "medium" } }, [
                    _vm._v("Medium"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "high" } }, [
                    _vm._v("High"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-task-item" }, [
          _c("label", [_vm._v("Owner")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "info-task-item-value" },
            [
              _c("a-select", {
                staticClass: "select-multiple",
                staticStyle: { width: "167px" },
                attrs: { options: _vm.users, placeholder: "Owner" },
                model: {
                  value: _vm.form.owner,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "owner", $$v)
                  },
                  expression: "form.owner",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-task-item" }, [
          _c("label", [_vm._v("Assignee")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "info-task-item-value" },
            [
              _c("a-select", {
                staticClass: "select-multiple",
                staticStyle: { width: "167px" },
                attrs: { options: _vm.users, placeholder: "Owner" },
                model: {
                  value: _vm.form.assignees,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "assignees", $$v)
                  },
                  expression: "form.assignees",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "info-task-item" }, [
          _c("label", [_vm._v("Task ID")]),
          _vm._v(" "),
          _c("div", { staticClass: "info-task-item-value" }, [
            _vm._v(_vm._s(_vm.form._id)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-task-item" }, [
          _c("label", [_vm._v("Created")]),
          _vm._v(" "),
          _c("div", { staticClass: "info-task-item-value" }, [
            _vm._v(_vm._s(_vm.form.createdAt)),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(2),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("div", { staticClass: "material-icons" }, [_vm._v("attachment")]),
      _vm._v(" "),
      _c("div", [_vm._v("Attach Files")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-task-item" }, [
      _c("label", [_vm._v("Completed Date")]),
      _vm._v(" "),
      _c("div", { staticClass: "info-task-item-value" }, [
        _vm._v("01.05.2024 5:41 am"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-task-item" }, [
      _c("label", [_vm._v("Last Updated")]),
      _vm._v(" "),
      _c("div", { staticClass: "info-task-item-value" }, [
        _vm._v("3 days ago"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }